import _ from 'lodash';

// The server template (sprightly) renders an unset key as a literal placeholder string instead of
// an empty value: 'undefined' for present-but-undefined, its 'N/A' keyFallback for missing
// (observed live: window.telephonyApiCode === 'undefined').
const TEMPLATE_PLACEHOLDER_VALUES = ['undefined', 'N/A'];

export const getEnvVariable = (key, fallbackValue) => {
  const value = _.get(window, key);
  const isEnvVarReplaced =
    !value?.startsWith?.('{{') && !TEMPLATE_PLACEHOLDER_VALUES.includes(value);

  if (value === 'true') {
    return true;
  }

  if (value === 'false') {
    return false;
  }

  if (isEnvVarReplaced) {
    return value;
  }

  return fallbackValue;
};
